import { useEffect, useRef } from "react";

import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";

import { toSubGroupFromCominParameter } from "../../../../../../helpers/et3-convert-array-sub-group";

import {
  TalkhattabatConversationType,
  TKhattabatMessage
} from "../../../../../../Types";

import UserMessageRow from "./UserMessageRow";

const UsersMessages = withLiteObserverAndTheme<{
  messages: TKhattabatMessage[];
  conversationID: string;
  conversationType: TalkhattabatConversationType;
}>((props) => {
  const {
    theme,
    messages,
    conversationID,
    conversationType
  } = props;

  const isOneOTwoConversation =
    conversationType === "102";

  const { colors, unitX, unitY } = theme;

  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current != null) {
      const scrollHeight =
        scrollRef.current.scrollHeight;

      scrollRef.current.scrollTo({
        top: scrollHeight
      });
    }
  }, [messages.length]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: 1248 * unitX,
        alignItems: "center",
        justifyContent: "flex-start",
        height: 340 * unitY,
        backgroundColor: colors.all.white,
        overflowX: "hidden"
      }}
      ref={scrollRef}
    >
      {toSubGroupFromCominParameter(
        messages
      ).map((subGroupData) => {
        return (
          <ET3Div
            width={1188}
            height={0}
            alignItems={"center"}
            fDirection={"column"}
            justifyContent={"center"}
            style={{
              minHeight: "unset"
            }}
            color={""}
            withShadow={false}
            isExtendable={true}
            isScrollable={false}
            onClick={() => { }}
          >
            {subGroupData.map(
              (khattabatMessage, index) => (
                <UserMessageRow
                  key={`${khattabatMessage.createdOn}_${index}`}
                  khattabatMessage={khattabatMessage}
                  isLastInSubGroup={
                    index === subGroupData.length - 1
                  }
                  conversationID={conversationID}
                  isOneOTwoConversation={
                    isOneOTwoConversation
                  }
                />
              )
            )}

            <Et3Margin
              top={8}
              bottom={8}
              left={0}
              right={0}
            />
          </ET3Div>
        );
      })}
    </div>
  );
});

export default UsersMessages;